import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "../common/functions";

export async function fleetsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    let shouldRedirect = false;

    for (const [key] of url.searchParams) {
        if (!["page", "limit"].includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }

    const formData = new FormData();
    formData.append("page", String(Number(url.searchParams.get("page"))));
    formData.append("limit", String(Number(url.searchParams.get("limit"))));

    const res = await myAxios({ fileName: "fleet/readFleets.php", formData });
    if (!res) throw redirect("..");
    return res.data;
}

export async function fleetLoader({ params }: LoaderFunctionArgs) {
    const fleetId = params.fleetId;
    if (!fleetId) throw redirect("/Fleets");

    const formData = new FormData();
    formData.append("id", fleetId);

    const res = await myAxios({ fileName: "fleet/readFleet.php", formData });
    if (!res || !res.data) throw redirect("..");
    return res.data;
}
